<template >
    <div class="container bg-white py-5 px-5" v-if="lesson">
      <h3>Нэр: {{lesson.name}}</h3>
      <div>
        <p>Кредит: {{lesson.credit}}</p>
      </div>
      <div v-if="rootlesson">
        <p v-if="rootlesson.hourForLecture">Лекцын цаг: {{rootlesson.hourForLecture}}</p>
        <p v-if="rootlesson.hourForLecture">Семинарын цаг: {{rootlesson.hourForSeminar}}</p>
      </div>
      <button type="button" class="btn btn-danger my-3" @click="_addProgram()">
        Ирц нэмэх
      </button>

      <!-- DataTales Example -->
      <div class="card mb-4" >
        <div class="card-header py-3">
          <h6 class="m-0 font-weight-bold text-primary">Ирц бүртгэл</h6>
        </div>
        <div class="card-body" v-if="pros!=null && pros.length>0">
          <div class="table-responsive">
            <table class="table table-bordered table-sm" id="dataTable" width="100%" cellspacing="0">
              <thead>
                <tr>
                  <th>№</th>
                  <th>Огноо</th>
                  <th>цаг</th>
                  <th>хичээлийн төрөл</th>
                  <th>хичээлийн үргэлжлэх</th>
                  
                  <th>Сэдэв</th>
                  <th>Төрөл</th>
                  <th>Үйлдэл</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(p, index) in pros" v-bind:key="p.id">
                  <td>{{index+1}}</td>
                  <td>
                    {{p.date | formatTimestamp}}
                  </td>
                  <td>
                    {{p.time}}-p цаг
                  </td>
                  <td>
                    <div v-if="p.lessonType">
                      <span v-if="p.lessonType=='lecture'">Лекц</span>
                      <span v-if="p.lessonType=='seminar'">Семинар</span>
                    </div>
                  </td>
                  <td>
                    <div v-if="p.durationHour">
                      <span v-if="p.durationHour==2">90 мин /{{p.durationHour}}цаг/</span>
                      <span v-if="p.durationHour==1">45 мин /{{p.durationHour}}цаг/</span>
                    </div>
                  </td>
           
                  <td>
                    <div v-if="p.topicData">
                      {{p.topicData.name}}
                    </div>
                    <div v-else class="text-danger">Сэдэв сонгоогүй</div>
                  </td>
                  <td>
                    <span v-if="p.type && p.type=='class'">Танхим</span>
                    <span v-if="p.type && p.type=='online'">Онлайн</span>
                  </td>
            
                  <td>
                    <button class="btn btn-warning btn-sm mr-2" @click="_editProgram(p)">засах</button>
                    <button class="btn btn-primary btn-sm" @click="$router.push({ name:'ILessonLogDetail', params:{ lessonId:lessonId, logId: p.id } })">харах</button>
                  </td>
                </tr>
                <tr>
                  <td colspan="4">
                  </td>
                  <td>
                    <div class="text-primary text-lg">Лекц &Sigma; : <span>{{_getSumofLessonType('lecture')}} цаг</span></div>
                    <div  class="text-primary text-lg">Семинар &Sigma; : <span>{{_getSumofLessonType('seminar')}} цаг</span></div>
                  </td>
                  <td colspan="3">
                  </td>
                </tr>
                
              </tbody>
            </table>
          </div>
        </div>
        <div v-else class="alert alert-warning">Одоогоор мэдээлэл ороогүй байна.</div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="proModal" tabindex="-1" role="dialog" aria-labelledby="proModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="proModalLabel">Ирц бүртгэx ангиа сонгоно уу</h5>
              <p class="mb-0" v-if="pro.date">{{pro.date | formatDate}}</p>
              <!-- <p>{{programYear.name}} - <span v-if="programYear.startDay">{{programYear.startDay.year}}</span></p> -->
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form class="user">
    
                <div class="row">
    
                  <div class="col form-group" >
                    <label for="exampleFormControlSelect1">Цаг :</label>

                    <select class="form-control"  v-model='pro.time'>
                      <option v-for="time in times" v-bind:value="time">
                        {{time}} -р цаг
                      </option>
                    </select>
                  </div>
                  
                </div>
                <div class="row">
                  <div class="col col-md-6 col-sm-12 form-group" >
                      <label >Хичээлийн төрөл :</label>

                      <select class="form-control"  v-model='pro.lessonType'>
                        <option value="lecture">
                          Лекц
                        </option>
                        <option value="seminar">
                          Семинар
                        </option>
                      </select>
                  </div>
                  <div class="col col-md-6 col-sm-12 form-group" >
                      <label >Хичээлийн үргэлжлэх цаг :</label>

                      <select class="form-control"  v-model='pro.timeType'>
                        <option value="2hour">
                          90 мин /2цаг/
                        </option>
                        <option value="1hour">
                          45 мин /1цаг/
                        </option>
                      </select>
                  </div>
                </div>
                <div class="form-group">

                    <label for="exampleFormControlSelect1">Төрөл :</label>

                    <select class="form-control"  v-model='pro.type'>
                      <option value="class">
                        Танхим
                      </option>
                      <option value="class">
                        Онлайн
                      </option>
                    </select>

                </div>
                <div class="row">
                  <div class="col form-group">
                    <label for="exampleFormControlSelect1">Сэдэв :</label>

                    <select class="form-control"  v-model='pro.topic'>
                      <option v-for="topic in topics" v-bind:value="topic.ref">
                        {{topic.name}}
                      </option>
                    </select>
                  </div>
                  
                </div>


                <hr>
                
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Цуцлаx</button>
              <button @click="_saveTopic" type="button" class="btn btn-primary btn-user btn-block" data-dismiss="modal">Xадгалаx</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    name: "ILessonLog",
    data() {
        return {
          school:null,
          lesson:null,
          times:[1, 2, 3, 4, 5, 6, 7, 8],
          pro:{
            program:null,
            topic:'class',
            type:null,
            date:new Date(),
            line:null,
            time:null
          },
          pros:[],
          topics:[],
          rootlesson:null
            
        };
    },
    methods: {
        
      _getQA(){
          // fb.db.collection("lessontypes").orderBy("index").get().then(docs=>{
          //   this.degrees=[];
          //   docs.docs.forEach(value=>{
          //     let object=value.data();
          //     object.id=value.id;
          //     object.ref=value.ref;
          //     this.degrees.push(object);
          //   });
          // });

          
          fb.db.collection("lessons").doc(this.lessonId).get().then(ldoc=>{
            if(ldoc && ldoc.exists){
              let item=ldoc.data();
              item.id=ldoc.id;
              this.lesson=item;
              if(item.rootlesson){
                item.rootlesson.get().then(doc=>{
                  console.log(doc.data());
                  if(doc.exists){
                    let rootlesson=doc.data();
                    rootlesson.id=doc.id;
                    this.rootlesson=rootlesson;
                    
                  }
                })
              }
              ldoc.ref.collection("topics").orderBy("createdAt").get().then(tdocs=>{
                this.topics=[];
                tdocs.forEach(value=>{
                
                  if(value.exists){
                    let object=value.data();
                    object.id=value.id;
                    object.ref=value.ref;
                    this.topics.push(object);
                  }
                })
              });

              ldoc.ref.collection("logs").orderBy("createdAt", "desc").onSnapshot(tdocs=>{
                this.pros=[];
                tdocs.forEach(value=>{
                  if(value.exists){
                    let object=value.data();
                    object.id=value.id;
                    object.ref=value.ref;
                    object.programData=null;
                    object.departmentData=null;
                    object.topicData=null;
                    object.groupData=null;
                    if(object.program)
                    {
                      object.program.get().then(pdoc=>{
                        if(pdoc.exists){
                          object.programData=pdoc.data();
                          if(pdoc.ref.parent.parent){
                            pdoc.ref.parent.parent.get().then(ddoc=>{
                              object.departmentData=ddoc.data();
                            });
                          }
                        }
                      });
                    }
                    if(object.group)
                    {
                      object.group.get().then(pdoc=>{
                        if(pdoc.exists){
                          object.groupData=pdoc.data();
                      
                        }
                      });
                    }
                    if(object.topic)
                    {
                      object.topic.get().then(pdoc=>{
                        if(pdoc.exists){
                          object.topicData=pdoc.data();
                          
                        }
                      });
                    }
                    this.pros.push(object);
                  }
                })
              });
            }
          });

      },

      _addProgram(){
          this.pro={
              program:null,
              topic:null,
              type:'class',
              date:new Date(),
              line:null,
              time:null,
              lessonType:'lecture',
              timeType:'2hour'
            };
          $('#proModal').modal('toggle');
      },
      _editProgram(pro){

          this.pro= Object.assign({}, pro);
          $('#proModal').modal('toggle');
      },
      async _saveTopic(){
        if(this.pro && this.pro.lessonType && this.pro.timeType){
          var docRef;
          if(this.pro && this.pro.id && this.pro.id!='' && this.pro.id!='new')
            docRef=fb.db.collection('lessons/'+this.lessonId+'/logs').doc(this.pro.id);
          else
            docRef=fb.db.collection('lessons/'+this.lessonId+'/logs').doc();
          this.pro.createdAt=new Date();
          if(this.pro.timeType){
            if(this.pro.timeType=='2hour'){
              this.pro.durationHour=2;
            }
            if(this.pro.timeType=='1hour'){
              this.pro.durationHour=1;
            }
          }
          if(this.currentUser && this.currentUser.uid)
            this.pro.user=fb.db.collection("users").doc(this.currentUser.uid);
          await docRef.set(this.pro);
          
          if(this.pro && this.pro.id && this.pro.id!='' && this.pro.id!='new'){
            this.pro={
              program:null,
              topic:null,
              type:'class',
              date:new Date(),
              line:null,
              time:null
            };
          }
          else{
            this.pro={
              program:null,
              topic:null,
              type:'class',
              date:new Date(),
              line:null,
              time:null
            };
            this.$router.push({name: 'ILessonLogDetail', params:{lessonId: this.lessonId, logId: docRef.id}});
          }
        }
        else
          alert("Та хичээлийн төрөл болон хичээлийн үргэлжлэх хугацааг сонгоно уу.");
      },
      _getSumofLessonType(type){
        var sum=0;
        if(type && this.pros && this.pros.length>0){
          for(const log of this.pros){
            if(log && log.lessonType && log.lessonType==type){
              if(log.durationHour){
                sum+=log.durationHour;
              }
              else if(log.timeType){
                if(log.timeType=='2hour')
                  sum+=2;
                else if(log.timeType=='1hour')
                  sum+=1;
              }
            }
          }
        }
        return sum;
      }
   

    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
      lessonId: { 
          required: true,
      }
    },
    created() {

      if(this.lessonId!=null && this.lessonId!='')
        this._getQA();
            
    },
    filters: {
		  formatTimestamp(val) {
        if(val!=null){
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm')
        }
        return '-'
      },
    
      formatDate(val) {
        if(val!=null){
          if (!val) { return '-' }
          let date = val;
          return moment(date).format('MM/DD/YYYY HH:mm');
        }
        return '-'
      },
    
    }
  
};
</script>

